import React from 'react'
import { ZinButton } from '@tnl/zin-react'
import { ACCOUNT_LOCKOUT } from '@constants'

interface AccountLockoutModalProps {
  onBackToSignIn?: () => void

  // Enhanced props for dynamic content and functionality
  body?: string
  buttonLabel?: string
  buttonAction?: () => void
  buttonVariant?: 'primary' | 'secondary'
  buttonDisabled?: boolean
}

export const AccountLockoutModal: React.FC<AccountLockoutModalProps> = ({
  onBackToSignIn,
  body = ACCOUNT_LOCKOUT.PASSWORD_BODY,
  buttonLabel = ACCOUNT_LOCKOUT.BACK_TO_SIGNIN_BUTTON,
  buttonAction,
  buttonVariant = 'primary',
  buttonDisabled = false,
}) => {
  // Determine button click handler (prioritize buttonAction, then onBackToSignIn)
  const handleButtonClick = buttonAction || onBackToSignIn || (() => {})

  return (
    <div className="account-lockout-modal__content">
      <div className="account-lockout-modal__message body-1 mb-6">{body}</div>

      <div className="account-lockout-modal__actions">
        <ZinButton
          full
          variant={buttonVariant}
          onClick={handleButtonClick}
          disabled={buttonDisabled}
          className="account-lockout-modal__button">
          {buttonLabel}
        </ZinButton>
      </div>
    </div>
  )
}
